import { StudioVisualizationType } from '@blockworks/platform/api/research/studio';

import type { GetVisualizationPropsResponse } from '../../../models';

type VisualizationTableProps = GetVisualizationPropsResponse<StudioVisualizationType.Table>;

const TABLE_FOOTER_HTML_ID = 'visualization-table-footer';
const TABLE_FOOTER_HEIGHT = 32;

export type { VisualizationTableProps };
export { TABLE_FOOTER_HEIGHT, TABLE_FOOTER_HTML_ID };
